// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_q9-8";
export var editMode = "_q9-3";
export var headerRow = "_q9-a";
export var headerTitle = "_q9-b";
export var product = "_q9-1";
export var productDetails = "_q9-5";
export var productDivider = "_q9-7";
export var productImage = "_q9-2";
export var productInfo = "_q9-4";
export var productTitle = "_q9-6";
export var strikethrough = "_q9-9";
export var upsellProductsCard = "_q9-0";